import { takeLatest, put } from 'redux-saga/effects';
import { BOOTING } from '../constants';
import { loadConfig } from '../actions';

export function* bootingError() {
  yield console.log('claro/Music * bootingError() saga');
}

export function* finishedBooting() {
  yield console.log('claro/Music * finishedBooting() saga');
}

export function* startBooting() {
  yield console.log('claro/Music * startBooting() saga');
  yield put(loadConfig());
}

export default function* bootingSaga() {
  yield takeLatest(BOOTING.ACTION, startBooting);
  yield takeLatest(BOOTING.SUCCESS, finishedBooting);
  yield takeLatest(BOOTING.ERROR, bootingError);
}
